import DateRange from "./DateRange";

export default {
  date: DateRange,
};
